<div class="pdf-page app-aul-006b-24" id="aul006b24">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>
      U.S. TERRORISM RISK INSURANCE ACT OF 2002 AS AMENDED <br />

      NOT PURCHASED CLAUSE</b
    >
  </p>

  <p class="font-small">
    <b>
      This Clause is issued in accordance with the terms and conditions of the
      "U.S. Terrorism Risk Insurance Act of 2002" as amended as summarized in
      the disclosure POLICYHOLDER DISCLOSURE NOTICE OF TERRORISM INSURANCE
      COVERAGE attached to this Policy.
    </b>
  </p>
  <br />
  <p class="font-small">
    It is hereby noted that the Company has made available coverage for “insured
    losses” directly resulting from an "act of terrorism" as defined in the
    "U.S. Terrorism Risk Insurance Act of 2002", as amended (“TRIA”) and the
    Insured has declined or not confirmed to purchase this coverage.
  </p>
  <p class="font-small">
    This Insurance (Policy) therefore affords no coverage for losses directly
    resulting from any "act of terrorism" as defined in TRIA except to the
    extent, if any, otherwise provided by this policy.
  </p>
  <p class="font-small">
    All other terms, conditions, insured coverage and exclusions of this
    Insurance (Policy) including applicable limits and deductibles remain
    unchanged and apply in full force and effect to the coverage provided by
    this Insurance (Policy).
  </p>
</div>
